import { runtimeConfig } from './runtime-config';
import { P } from '@wevo/wevo-access';

const apiScopes = Object.values(P.WEVO.ACCESS.API).join(' ');

export const auth0Config = {
    domain: runtimeConfig.auth0.domain,
    clientId: runtimeConfig.auth0.clientId,
    redirectUri: window.location.origin,
    audience: runtimeConfig.auth0.audience,
    scope: `openid profile email roles ${apiScopes}`,
};

export const apiConfig = {
    accessApiUrl: runtimeConfig.api.accessApiUrl,
    managementApiUrl: runtimeConfig.api.managementApiUrl,
};
